import React, { Component } from 'react';
import '../../../App.css';
import '../../../styles/app-demo.css';
import BillPayLanding from './bill-pay-landing';
import SelectPayee from './select-payee';
import PayAmount from './pay-amount';
import PaymentFrequency from './payment-frequency';
import BillPayDate from './bill-pay-date';
import ConfirmPayment from './confirm-payment'

class BillPay extends Component {

  constructor(props){
    super(props)
    this.state = {
      billPayRoute: 'home',
      footerUnderline: 'bill pay',
      amount: null,
      frequency: null,
      date: null
    }
    this.handleBillPayRoute = this.handleBillPayRoute.bind(this);
    this.toggleNewRoute = this.toggleNewRoute.bind(this);
    this.submitAmount = this.submitAmount.bind(this);
    this.paymentFrequency = this.paymentFrequency.bind(this)
    this.submitDate = this.submitDate.bind(this);
    this.updateBillPayList = this.updateBillPayList.bind(this);
  }

  toggleNewRoute(routeName) {
    this.props.toggleNewRoute(routeName);
  }

  handleBillPayRoute(route) {
    console.log(route)
    this.setState({
      billPayRoute: route
    })
  }

  submitAmount(amount) {
    this.setState({
      amount
    })
  }

  paymentFrequency(frequency) {
    this.setState({
      frequency
    })
  }

  submitDate(date) {
    this.setState({
      date
    })
  }

  updateBillPayList(transaction) {
    this.props.updateBillPayList(transaction)
  }

  render() {

    return (
      <section>
        {
          this.state.billPayRoute === 'home' ?
          <BillPayLanding {...this.state} {...this.props} toggleNewRoute={this.toggleNewRoute} handleBillPayRoute={this.handleBillPayRoute} />
          :
          null
        }
        {
          this.state.billPayRoute === 'select payee' ?
          <SelectPayee {...this.state} toggleNewRoute={this.toggleNewRoute} handleBillPayRoute={this.handleBillPayRoute} />
          :
          null
        }
        {
          this.state.billPayRoute === 'pay amount' ?
          <PayAmount {...this.state} submitAmount={this.submitAmount} toggleNewRoute={this.toggleNewRoute} handleBillPayRoute={this.handleBillPayRoute} />
          :
          null
        }
        {
          this.state.billPayRoute === 'payment frequency' ?
          <PaymentFrequency {...this.state} paymentFrequency={this.paymentFrequency} toggleNewRoute={this.toggleNewRoute} handleBillPayRoute={this.handleBillPayRoute} />
          :
          null
        }
        {
          this.state.billPayRoute === 'bill pay date' ?
          <BillPayDate {...this.state} submitDate={this.submitDate} toggleNewRoute={this.toggleNewRoute} handleBillPayRoute={this.handleBillPayRoute} />
          :
          null
        }
        {
          this.state.billPayRoute === 'confirm payment' ?
          <ConfirmPayment {...this.state} updateBillPayList={this.updateBillPayList} toggleNewRoute={this.toggleNewRoute} handleBillPayRoute={this.handleBillPayRoute} />
          :
          null
        }
      </section>
    );
  }
}

export default BillPay;
